/**
 * University of Illinois Chicago (UIC) tenant configuration
 */

import type { TenantConfig } from '../types'
import { defaultFeatures, defaultSupport } from './base'

const uicConfig: TenantConfig = {
  tenant: 'uic',

  branding: {
    name: 'University of Illinois Chicago',
    shortName: 'UIC',
    logo: 'logos/uic.png',
    favicon: 'favicon.ico',
    primaryColor: '#001E62',    // UIC Navy
    secondaryColor: '#D50032',  // UIC Red
    accentColors: [
      '#0065AD',  // Medium blue
      '#FFBF3F',  // Gold
      '#41B6E6',  // Light blue
    ],
    theme: 'light',             // Light header/footer (white bg, dark text)
    heroImage: 'backgrounds/uic.jpg',
    headerText: '',
  },

  features: {
    ...defaultFeatures,
    minorSelection: false,
    twoToFourYear: false,
    savedPlans: false,
  },

  dataSource: 'larx',

  institutions: {
    destination: {
      name: 'University of Illinois Chicago',
    },
    startingSchools: [
      {
        name: 'City Colleges of Chicago',
        slug: 'ccc',
        enabled: true,
      },
    ],
  },

  // Auth disabled for now (savedPlans: false)
  // auth: {
  //   provider: 'cognito',
  //   poolId: import.meta.env.VITE_COGNITO_USER_POOL_ID || '',
  //   clientId: import.meta.env.VITE_COGNITO_CLIENT_ID || '',
  // },

  support: {
    ...defaultSupport,
    contactEmail: 'transfer@uic.edu',
    helpUrl: 'https://admissions.uic.edu/transfer',
  },

  content: {
    heroTitle: 'Transfer your community college credits to UIC',
    heroCTAText: 'Transfer to UIC',
    nav: {
      transferLabel: 'Transfer to UIC',
    },
    footer: {
      addressLine: 'University of Illinois Chicago | 1200 W Harrison St, Chicago, IL 60607',
      contactLine: 'Phone: (312) 996-7000',
      copyrightLine: '© 2024 The Board of Trustees of the University of Illinois',
    },
  },
}

export default uicConfig
